import React, { useContext } from 'react'
import { EventContext } from './EventContext'

const CalendarFilter = () => {
	const { types, $type, set$type } = useContext(EventContext)
	const hideType = [
		'Next Step Up Programs',
		'Teen Programs',
		'Member Programs',
		'Young Adult Program',
		'Multi-Generational Program',
	]

	function onChange({ target }) {
		set$type(target.value)
	}

	return (
		<nav className="flex">
			<label className="flex items-center gap-2 ml-auto">
				Filter by:

				<select className="select p-2" onChange={onChange} value={$type}>
					<option value={''}>All</option>

					{types?.map((type, key) => (
						hideType.indexOf(type) < 0 &&
							<option value={type} key={key}>{type}</option>
					))}
				</select>
			</label>
		</nav>
	)
}

export default CalendarFilter
